import { useRouter } from 'next/router'
import { useMemo } from 'react'

const key = 'sid'

export const useSessionId: () => string = () => {
  const router = useRouter()
  return useMemo(() => {
    return router.query[key]?.toString() || ''
  }, [router.query[key]])
}
